export const EMAIL_TYPE = 'email'
export const LIVE_CHAT_WIDGET_TYPE = 'liveChat'
